import { render, staticRenderFns } from "./DynamicVueSelect.vue?vue&type=template&id=722e54e4&scoped=true"
import script from "./DynamicVueSelect.vue?vue&type=script&lang=js"
export * from "./DynamicVueSelect.vue?vue&type=script&lang=js"
import style0 from "./DynamicVueSelect.vue?vue&type=style&index=0&id=722e54e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722e54e4",
  null
  
)

export default component.exports